import { Card, CardBody } from "reactstrap"
import SectionHeader from "./SectionHeader"

export default function DataCard({
  title = "Information",
  icon = "bx bx-data",
  data = [],
  action = null,
  noDataText = "No Data",
}) {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardBody className="p-3">
        <SectionHeader icon={icon} title={title} action={action} />
        <div className="specs-list">
          {data?.length
            ? data.map((item, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between py-2 border-bottom"
                >
                  <span className="text-muted">{item.label}:</span>
                  <span className="fw-medium">{item.value ?? "-"}</span>
                </div>
              ))
            : <small>{noDataText}</small>}
        </div>
      </CardBody>
    </Card>
  )
}
